import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { classNames } from '../utils/classNames';

export interface LinkButtonBaseProps {
  readonly children?: ReactNode;
  readonly id?: string;
  readonly className?: string;
  readonly outline?: boolean;
  readonly color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'link'
    | ''
    | 'danger'
    | 'info'
    | 'warning';
  readonly block?: boolean;
  readonly disabled?: boolean;
}

// Force to or href to be provided, but never both.
interface LinkButtonProps extends LinkButtonBaseProps {
  readonly to: string;
}

export const LinkButton: FC<LinkButtonProps> = ({
  id,
  children,
  block,
  outline,
  color = 'primary',
  className = '',
  disabled,
  to,
}) => {
  const btnOutlineColor = color ? `btn${outline ? '-outline' : ''}-${color}` : '';

  return (
    <Link
      className={`${classNames({ 'd-block': block, 'w-100': block, disabled }, `btn ${btnOutlineColor}`)} ${className}`}
      id={id}
      to={to}
    >
      {children}
    </Link>
  );
};
